import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledSection = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;

  ${({ styles }) => styles}
`;

const Section = ({ children, styles, className }) => (
  <StyledSection styles={styles} className={className}>
    {children}
  </StyledSection>
);

Section.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array,
  ]).isRequired,
  styles: PropTypes.array,
  className: PropTypes.string,
};

Section.defaultProps = {
  styles: [],
  className: '',
};

export default Section;
